module.exports = __webpack_public_path__ + "static/media/student33.733a28ca.png";